// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import less from 'less'
Vue.use(less)


import '@/assets/css/reset.css'; //引用css重置样式
import '@/assets/css/animate.css'; //引用动画css

// 引入滚动动画
import VueAnimateOnScroll from '@/assets/js/animateScroll';
Vue.use(VueAnimateOnScroll)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import http from './api/http'
Vue.prototype.http = http;

import 'vue2-animate/dist/vue2-animate.min.css'

import { JSEncrypt } from 'jsencrypt';
//JSEncrypt加密方法
Vue.prototype.$encryptedData = function (publicKey, password) {
  //new一个对象
  let encrypt = new JSEncrypt()
  //设置公钥
  encrypt.setPublicKey(publicKey)
  //data是要加密的数据,此处不用注意+号,因为rsa自己本身已经base64转码了,不存在+,全部是二进制数据
  let result = encrypt.encrypt(password)
  return result;
}
//JSEncrypt解密方法
Vue.prototype.$decryptData = function (privateKey, password) {
  // 新建JSEncrypt对象
  let decrypt = new JSEncrypt()
  // 设置私钥
  decrypt.setPrivateKey(privateKey)
  // 解密数据
  let result = decrypt.decrypt(password)
  return result;
}
import Rsa from "./utilities/RsaPassWord";
Vue.prototype.Rsa = Rsa;

var vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
http.init(vue);

Vue.config.productionTip = false;


// WEBPACK FOOTER //
// ./src/main.js